import { Box, Grid, Paper, Text } from '@mantine/core';
import { sumBy } from 'lodash';

interface TaxSummary {
  taxType: string;
  total: number;
}

interface UTBTotalProps {
  resources: TaxSummary[];
  t: (path: string, variables?: Record<string, any>) => string;
}

export const UTBTotal = ({ resources, t }: UTBTotalProps) => {
  return (
    <Paper withBorder mb="xs">
      <Box p="xs">
        <Grid>
          <Grid.Col span={3}>
            <Text>{t('TOTAL.INVITATIONS')}</Text>
          </Grid.Col>
          <Grid.Col span={9} />
        </Grid>
        <Grid>
          <Grid.Col span={3} />
          <Grid.Col span={6}>
            <Text>{t('TOTAL.DUE')}</Text>
          </Grid.Col>
          <Grid.Col span={3}>
            <Text>€ {sumBy(resources, (resource) => resource.total || 0) || 'NIHIL'}</Text>
          </Grid.Col>
        </Grid>
      </Box>
    </Paper>
  );
};
